import { HttpClient } from '../../httpClient'
import { throwIfNotAllowedContentType, validateHttpResponse } from '../../httpClient/utils.ts'

export interface UpdateUserDto {
	username?: string
	name?: string
	primaryEmail?: string
	primaryPhone?: string
	avatar?: string
}

export const updateUser = async (client: HttpClient, userId: string, updateData: UpdateUserDto) => {
	const response = await client.put(`/api/v2/users/${userId}`, updateData)

	await validateHttpResponse(response)
	throwIfNotAllowedContentType(response, ['application/json'])

	return response.data
}
